<app-header></app-header>
<app-list-management-skeleton
  [class.hide]="!isLoading"
  [platform]="platformService?.platformType"
></app-list-management-skeleton>
<!-- Start of Desktop Content -->
<ion-content
  *ngIf="(platformService?.isTouchExperience$ | async) === false"
  id="desktop"
  class="gray-content-bg"
  [listItems]="vm?.listItems"
  [groups]="vm?.listGroups"
  [list]="vm?.list"
  scroll-y="false"
  lmaDragDropContainer
>
  <cdk-virtual-scroll-viewport
    [class.hide]="isLoading"
    data-cy="list-management-desktop-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="vm?.itemHeights"
    [indexOffset]="1"
    [listId]="vm?.list?.listKey?.listId"
  >
    <!-- Breadcrumbs -->
    <ion-grid [fixed]="true">
      <ion-row class="breadcrumbs-section">
        <ion-col size="8">
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </ion-col>
        <ion-col *ngIf="vm?.list?.listItemCount > 0" size="4">
          <ion-row class="interact-download">
            <ion-label (click)="openDownloadPrintModal(false)">
              <ion-icon name="print-outline"></ion-icon>
              {{ 'i18n.common.print' | translate }}
            </ion-label>
            <ion-label (click)="openDownloadPrintModal(true)">
              <ion-icon name="download-outline"></ion-icon>
              {{ 'i18n.common.download' | translate }}
            </ion-label>
          </ion-row>
        </ion-col>
      </ion-row>
      <!-- List Banner -->
      <app-list-banner
        [listName]="vm?.list?.listName"
        [listItemCount]="vm?.list?.listItemCount"
        [showEllipsis]="true"
        (ellipsisClickEventEmitter)="openListOptions($event)"
      ></app-list-banner>
      <!-- Search, Sort & Filter -->
      <ion-row
        class="ion-margin-top"
        [class.hide]="vm?.list?.listItemCount === 0"
      >
        <ion-col size-xl="9" size-lg="8" size-md="7" size-sm="12" size-xs="12">
          <ng-container [ngTemplateOutlet]="searchSortFilter"></ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid [fixed]="true">
      <!-- Product Cards -->
      <ion-row *cdkVirtualFor="let item of vm?.items; let i = index;">
        <ion-col size-xl="9" size-lg="9" size-md="9" size-sm="12" size-xs="12">
          <div
            *ngIf="item?.itemType === ItemTypes.group && item?.groupName === vm?.selectedGroup?.groupName"
            [attr.data-cy]="'list-management-group-info-section-' + i"
            class="group-info-section"
          >
            <ion-label
              [attr.data-cy]="'list-management-group-name-text-' + i"
              class="group-name-text"
            >
              {{ item?.groupName }}
              <span
                [attr.data-cy]="'list-management-group-product-count-text-' + i"
              >
                ({{ item?.itemCount || 0 }}&nbsp;{{ (item?.itemCount > 1 ||
                !item?.itemCount ? 'i18n.lists.products' : 'i18n.lists.product')
                | translate }})
              </span>
            </ion-label>
            <ion-icon
              *ngIf="item?.groupName !== 'Unassigned Group'"
              [attr.data-cy]="'list-management-group-options-button-' + i"
              name="ellipsis-vertical"
              slot="end"
              (click)="openGroupManagementOptions($event)"
            ></ion-icon>
          </div>
          <app-usf-product-card-desktop
            *ngIf="item?.itemType === ItemTypes.product && item?.groupName === vm?.selectedGroup?.groupName"
            [vm]="{
              mode: mode,
              product: item,
              index: i,
              itemType: item?.itemType,
              list: vm?.list,
              isSelected: item?.isChecked,
              pricingDisabled: vm?.selectedCustomer?.ogPrintPriceInd === 'N'
            }"
            [item]="item"
            [isChecked]="item?.isChecked"
            [showNotes]="(vm?.list?.listKey?.listTypeId !== ListTypes.og && vm?.listItemNoteFeatureFlag) || (!vm?.listItemNoteFeatureFlag && item?.item?.note)"
            [listItemNoteFeatureFlag]="vm?.listItemNoteFeatureFlag"
            (ellipsisEmitter)="openProductCardEllipsis($event)"
            (infoIconClickEmitter)="openProductStatus($event)"
            (itemNoteClickEmitter)="openItemNotes($event)"
            (productCardClickEmitter)="routeToPDP($event)"
            (resequenceProductEmitter)="resequenceProduct($event)"
            (productConversionEmitter)="handleProductConversionClick($event)"
            lmaDragDropItem
          >
            <app-usf-checkbox
              [isSelected]="item?.isChecked"
              (selectEmitter)="updateSelectedProducts(
                item?.item?.listKey,
                item?.item?.listGroupKey?.listGroupId,
                item?.item?.listItemKey?.listItemId,
                item?.isChecked
              )"
            ></app-usf-checkbox>
          </app-usf-product-card-desktop>
        </ion-col>
      </ion-row>
      <!-- No Results -->
      <ion-row>
        <ion-col size-xl="9" size-lg="9" size-md="9" size-sm="12" size-xs="12">
          <app-no-products-in-group
            [listCount]="vm?.list?.listItemCount"
            [itemsLeftAfterFilter]="vm?.items?.length"
            [isEditableList]="true"
            [isMobile]="false"
            [isListManagement]="true"
          ></app-no-products-in-group>
        </ion-col>
      </ion-row>
    </ion-grid>
    <!-- Footer -->
    <div class="footer-section">
      <app-footer></app-footer>
    </div>
  </cdk-virtual-scroll-viewport>
  <!-- Sidebar -->
  <div #sidebar class="desktop-sidebar">
    <ion-grid [fixed]="true">
      <ion-row>
        <ion-col offset-xl="9" offset-lg="9" offset-md="9"></ion-col>
        <ion-col>
          <ng-container [ngTemplateOutlet]="groupsSidebar"></ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <!-- Selected Products Footer -->
  <ng-container [ngTemplateOutlet]="selectedProductsFooter"></ng-container>
</ion-content>

<!-- Start of Tablet Content -->
<ion-content
  *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
  id="tablet"
  class="gray-content-bg"
  [listItems]="vm?.listItems"
  [groups]="vm?.listGroups"
  [list]="vm?.list"
  scroll-y="false"
  lmaDragDropContainer
>
  <cdk-virtual-scroll-viewport
    data-cy="list-management-tablet-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="vm?.itemHeights"
    [indexOffset]="1"
    [listId]="vm?.list?.listKey?.listId"
  >
    <!-- List Banner -->
    <app-list-banner
      [listName]="vm?.list?.listName"
      [listItemCount]="vm?.list?.listItemCount"
      [showEllipsis]="true"
      (ellipsisClickEventEmitter)="openListOptions($event)"
      (downloadClickEventEmitter)="openDownloadPrintModal(true)"
      (printClickEventEmitter)="openDownloadPrintModal(false)"
    ></app-list-banner>

    <ion-grid [fixed]="true">
      <!-- Search, Sort & Filter -->
      <ion-row
        class="ion-margin-top"
        [class.hide]="vm?.list?.listItemCount === 0"
      >
        <ion-col size-xl="9" size-lg="8" size-md="7" size-sm="12" size-xs="12">
          <ng-container [ngTemplateOutlet]="searchSortFilter"></ng-container>
        </ion-col>
      </ion-row>
      <!-- Product Cards -->
      <ion-row *cdkVirtualFor="let item of vm?.items;let i = index">
        <ion-col size-xl="9" size-lg="9" size-md="8" size-sm="8" size-xs="8">
          <div
            *ngIf="item?.itemType === ItemTypes.group && item?.groupName === vm?.selectedGroup?.groupName"
            [attr.data-cy]="'list-management-group-info-section-' + i"
            class="group-info-section"
          >
            <ion-label
              [attr.data-cy]="'list-management-group-name-text-' + i"
              class="group-name-text"
            >
              {{ item?.groupName }}
              <span
                [attr.data-cy]="'list-management-group-product-count-text-' + i"
              >
                ({{ item?.itemCount || 0 }}&nbsp;{{ (item?.itemCount > 1 ||
                !item?.itemCount ? 'i18n.lists.products' : 'i18n.lists.product')
                | translate }})
              </span>
            </ion-label>
            <ion-icon
              *ngIf="item?.groupName !== 'Unassigned Group'"
              [attr.data-cy]="'list-management-group-options-button-' + i"
              name="ellipsis-vertical"
              slot="end"
              (click)="openGroupManagementOptions($event)"
            ></ion-icon>
          </div>
          <app-usf-product-card-touch
            *ngIf="item?.itemType === ItemTypes.product && item?.groupName === vm?.selectedGroup?.groupName"
            [vm]="{
              mode: mode,
              product: item,
              index: i,
              itemType: item?.itemType,
              list: vm?.list,
              isSelected: item?.isChecked,
              pricingDisabled: vm?.selectedCustomer?.ogPrintPriceInd === 'N'
            }"
            [item]="item"
            [isChecked]="item?.isChecked"
            [showNotes]="(vm?.list?.listKey?.listTypeId !== ListTypes.og && vm?.listItemNoteFeatureFlag) || (!vm?.listItemNoteFeatureFlag && item?.item?.note)"
            [listItemNoteFeatureFlag]="vm?.listItemNoteFeatureFlag"
            (ellipsisEmitter)="openProductCardEllipsis($event)"
            (infoIconClickEmitter)="openProductStatus($event)"
            (itemNoteClickEmitter)="openItemNotes($event)"
            (productCardClickEmitter)="routeToPDP($event)"
            (resequenceProductEmitter)="resequenceProduct($event)"
            (productConversionEmitter)="handleProductConversionClick($event)"
            lmaDragDropItem
          >
            <app-usf-checkbox
              [isSelected]="item?.isChecked"
              (selectEmitter)="updateSelectedProducts(
                item?.item?.listKey,
                item?.item?.listGroupKey?.listGroupId,
                item?.item?.listItemKey?.listItemId,
                item?.isChecked
              )"
            ></app-usf-checkbox>
          </app-usf-product-card-touch>
        </ion-col>
      </ion-row>
      <!-- No Results -->
      <ion-row>
        <ion-col size-xl="9" size-lg="9" size-md="8" size-sm="8" size-xs="8">
          <app-no-products-in-group
            [listCount]="vm?.list?.listItemCount"
            [itemsLeftAfterFilter]="vm?.items?.length"
            [isEditableList]="true"
            [isMobile]="false"
            [isListManagement]="true"
          ></app-no-products-in-group>
        </ion-col>
      </ion-row>
    </ion-grid>
  </cdk-virtual-scroll-viewport>
  <!-- Sidebar -->
  <div #sidebar class="tablet-sidebar">
    <ion-grid [fixed]="true">
      <ion-row>
        <ion-col
          size-xl="9"
          size-lg="9"
          size-md="8"
          size-sm="8"
          size-xs="8"
        ></ion-col
        ><ion-col>
          <ng-container [ngTemplateOutlet]="groupsSidebar"></ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <!-- Selected Products Footer -->
  <ng-container [ngTemplateOutlet]="selectedProductsFooter"></ng-container>
</ion-content>

<!-- Start of Mobile Content -->
<ion-content
  *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
  id="mobile"
  class="gray-content-bg"
  [listItems]="vm?.listItems"
  [groups]="vm?.listGroups"
  [list]="vm?.list"
  scroll-y="false"
  lmaDragDropContainer
>
  <cdk-virtual-scroll-viewport
    data-cy="list-management-mobile-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="vm?.itemHeights"
    [indexOffset]="1"
    [listId]="vm?.list?.listKey?.listId"
  >
    <!-- List Groups -->
    <app-list-groups-mobile
      [list]="vm?.list"
      [selectedGroup]="vm?.selectedGroup?.groupName"
      [groups]="vm?.managementSidebarGroups"
      (changeGroupEmitter)="changeSelectedGroup($event)"
      (dragDropEmitter)="resequenceGroup($event)"
      #listGroups
    >
      <!-- Search, Sort & Filter within app-list-groups-mobile, needed when no group is selected -->
      <ion-grid
        [class.hide]="vm?.list?.listItemCount === 0 || vm?.selectedGroup"
        style="padding-bottom: 0rem"
      >
        <ion-row class="ion-margin-top">
          <ion-col
            size-xl="9"
            size-lg="8"
            size-md="7"
            size-sm="12"
            size-xs="12"
          >
            <ng-container [ngTemplateOutlet]="searchSortFilter"></ng-container>
          </ion-col>
        </ion-row>
      </ion-grid>
    </app-list-groups-mobile>
    <ion-grid [fixed]="true">
      <!-- List Banner -->
      <app-list-banner
        *ngIf="vm?.selectedGroup"
        [listName]="vm?.list?.listName"
        [listItemCount]="vm?.list?.listItemCount"
        [showEllipsis]="true"
        (ellipsisClickEventEmitter)="openListOptions($event)"
      ></app-list-banner>
      <!-- Search, Sort & Filter -->
      <ion-row
        class="ion-margin-top"
        [class.hide]="vm?.list?.listItemCount === 0 || !vm?.selectedGroup"
      >
        <ion-col size-xl="9" size-lg="8" size-md="7" size-sm="12" size-xs="12">
          <ng-container [ngTemplateOutlet]="searchSortFilter"></ng-container>
        </ion-col>
      </ion-row>
      <!-- Product Cards -->
      <ion-row *cdkVirtualFor="let item of vm?.items; let i = index">
        <ion-col size="12">
          <div
            *ngIf="item?.itemType === ItemTypes.group && item?.groupName === vm?.selectedGroup?.groupName"
            [attr.data-cy]="'list-management-group-info-section-' + i"
            class="group-info-section"
          >
            <ion-label
              [attr.data-cy]="'list-management-group-name-text-' + i"
              class="group-name-text"
            >
              {{ item?.groupName | truncateWithEllipsis: 25 }}&nbsp;({{
              item?.itemCount || 0}})
            </ion-label>
            <ion-icon
              [attr.data-cy]="'list-management-group-options-button-' + i"
              *ngIf="item?.groupName !== 'Unassigned Group'"
              name="ellipsis-vertical"
              (click)="openGroupManagementOptions($event)"
            ></ion-icon>
          </div>
          <app-usf-product-card-touch
            *ngIf="item?.itemType === ItemTypes.product && item?.groupName === vm?.selectedGroup?.groupName"
            [vm]="{
              mode: mode,
              product: item,
              index: i,
              itemType: item?.itemType,
              list: vm?.list,
              isSelected: item?.isChecked,
              pricingDisabled: vm?.selectedCustomer?.ogPrintPriceInd === 'N'
            }"
            [item]="item"
            [isChecked]="item?.isChecked"
            [showNotes]="(vm?.list?.listKey?.listTypeId !== ListTypes.og && vm?.listItemNoteFeatureFlag) || (!vm?.listItemNoteFeatureFlag && item?.item?.note)"
            [listItemNoteFeatureFlag]="vm?.listItemNoteFeatureFlag"
            (ellipsisEmitter)="openProductCardEllipsis($event)"
            (infoIconClickEmitter)="openProductStatus($event)"
            (itemNoteClickEmitter)="openItemNotes($event)"
            (productCardClickEmitter)="routeToPDP($event)"
            (resequenceProductEmitter)="resequenceProduct($event)"
            (productConversionEmitter)="handleProductConversionClick($event)"
            lmaDragDropItem
          >
            <app-usf-checkbox
              [isSelected]="item?.isChecked"
              (selectEmitter)="updateSelectedProducts(
                item?.item?.listKey,
                item?.item?.listGroupKey?.listGroupId,
                item?.item?.listItemKey?.listItemId,
                item?.isChecked
              )"
            ></app-usf-checkbox>
          </app-usf-product-card-touch>
        </ion-col>
      </ion-row>
      <!-- No Results -->
      <ion-row *ngIf="vm?.selectedGroup">
        <ion-col size="12">
          <app-no-products-in-group
            [listCount]="vm?.list?.listItemCount"
            [itemsLeftAfterFilter]="vm?.items?.length"
            [isEditableList]="true"
            [isMobile]="true"
            [isListManagement]="true"
          ></app-no-products-in-group>
        </ion-col>
      </ion-row>
    </ion-grid>
  </cdk-virtual-scroll-viewport>

  <!-- Selected Products Footer -->
  <div
    *ngIf="vm?.numProductsSelected >= 1 && vm?.selectedGroup"
    id="product-selection-footer"
    data-cy="list-management-selected-products-footer"
    class="selected-products-footer"
  >
    <div class="selection-buttons">
      <span
        data-cy="list-management-selected-products-text"
        (click)="selectAllProducts()"
        class="bold"
      >
        {{ 'i18n.lists.selectAll' | translate }}
      </span>
      <span
        data-cy="list-management-selected-products-text"
        (click)="deselectAllProducts()"
      >
        {{ 'i18n.lists.deselectAll' | translate }}
      </span>
    </div>
    <ion-button
      data-cy="list-management-selected-products-button"
      class="usf-outline-green-button"
      (click)="openSelectedProductsModal('')"
    >
      {{ (vm?.numProductsSelected-0) }}&nbsp;{{ 'i18n.lists.selected' |
      translate }}
      <ion-icon
        data-cy="list-management-selected-products-button-icon"
        name="chevron-forward-outline"
      ></ion-icon>
    </ion-button>
  </div>
</ion-content>

<div
  [class.static-buttons]="platformService.platformType === platformService.platformEnum.mobile && showTopButton"
  [class.has-selection]="vm?.numProductsSelected > 0"
  data-cy="list-management-static-buttons-section"
>
  <ng-container
    *ngIf="platformService.platformType === platformService.platformEnum.mobile"
  >
    <ion-button
      *ngIf="vm?.selectedGroup && vm?.numProductsSelected === 0 && !vm?.multipleProductFlag"
      data-cy="list-management-add-products-button"
      class="add-products-btn-mobile usf-fill-green-mobile-modal-button"
      (click)="onAddProductAction()"
    >
      {{ 'i18n.common.addProducts' | translate }}
    </ion-button>
    <ion-button
      *ngIf="vm?.selectedGroup && vm?.numProductsSelected === 0 && vm?.multipleProductFlag"
      data-cy="list-management-add-products-button"
      class="add-products-btn-mobile usf-outline-green-button"
      (click)="onAddProductClick()"
    >
      {{ 'i18n.common.addProducts' | translate }}
      <ion-icon
        class="arrow-icon"
        src="assets/icon/ios-arrow-down.svg"
        slot="end"
      ></ion-icon>
    </ion-button>
    <ion-button
      *ngIf="!vm?.selectedGroup"
      data-cy="list-management-add-group-button"
      class="add-group-btn-mobile usf-fill-green-mobile-modal-button"
      (click)="onClickAddGroup()"
    >
      {{ 'i18n.lists.addGroup' | translate }}
    </ion-button>
  </ng-container>

  <div
    *ngIf="showTopButton"
    data-cy="list-management-top-button-section"
    class="top-button"
  >
    <ion-button
      data-cy="list-management-top-button"
      class="usf-fill-green-button"
      (click)="goToTop()"
    >
      {{ 'i18n.common.top' | translate }}&nbsp;
      <ion-icon
        data-cy="list-detail-top-button-icon"
        name="chevron-up-circle-outline"
      ></ion-icon>
    </ion-button>
  </div>
</div>

<!-- GROUPS SIDEBAR TEMPLATE -->
<ng-template #groupsSidebar>
  <div #sidebarGroupsSection class="groups-sidebar">
    <div class="add-products-section">
      <ion-button
        data-cy="list-management-add-products-button"
        *ngIf="!vm?.multipleProductFlag"
        class="usf-fill-green-button"
        (click)="onAddProductAction()"
      >
        {{ 'i18n.common.addProducts' | translate }}
      </ion-button>
      <ion-button
        [hidden]="!vm?.multipleProductFlag"
        id="add-products-button"
        data-cy="list-management-add-products-button"
        class="usf-outline-green-button"
        (click)="onAddProductClick()"
      >
        {{ 'i18n.common.addProducts' | translate }}
        <ion-icon slot="end" name="chevron-down-outline"></ion-icon>
      </ion-button>
      <ion-popover
        *ngIf="platformService?.platformType === platformService?.platformEnum.desktop"
        data-cy="add-products-popover"
        class="add-products-popover"
        mode="ios"
        showBackdrop="false"
        trigger="add-products-button"
        dismissOnSelect="true"
      >
        <ng-template>
          <app-ellipsis-options-popover
            class="popover-viewport"
            [buttons]="addProductsButtons$ | async"
          ></app-ellipsis-options-popover>
        </ng-template>
      </ion-popover>
    </div>
    <div
      data-cy="list-groups-header-section"
      class="list-groups-header-section"
    >
      <span data-cy="list-management-add-group-text">
        {{ 'i18n.lists.groups' | translate }}
      </span>
      <ion-button
        id="add-group-button"
        data-cy="list-management-add-group-button"
        class="usf-outline-green-button"
        (click)="onClickAddGroup()"
      >
        {{ 'i18n.lists.addGroup' | translate }}
      </ion-button>
    </div>
    <div id="list-groups-section" class="groups-list-section" cdkScrollable>
      <app-list-groups-desktop-tablet
        [list]="vm?.list"
        [groups]="vm?.managementSidebarGroups"
        [selectedGroup]="vm?.selectedGroup?.groupName"
        (changeGroupEmitter)="changeSelectedGroup($event)"
        (dragDropEmitter)="resequenceGroup($event)"
        (createGroupEmitter)="createGroup($event)"
        #listGroups
      ></app-list-groups-desktop-tablet>
    </div>
  </div>
</ng-template>

<!-- SELECTED PRODUCTS FOOTER TEMPLATE -->
<ng-template #selectedProductsFooter>
  <ion-card
    *ngIf="vm?.numProductsSelected >= 1"
    id="product-selection-footer"
    data-cy="list-management-selected-products-footer"
    class="selected-products-footer"
  >
    <div class="selection-options">
      <ion-text data-cy="list-management-num-selected-products-text">
        {{ (vm?.numProductsSelected-0)}}&nbsp;{{ ((vm?.numProductsSelected-0) >
        1 ? 'i18n.lists.products' : 'i18n.lists.product') | translate }}&nbsp;{{
        'i18n.lists.selected' | translate }}
      </ion-text>
      <span data-cy="list-management-separator-text">|</span>
      <ion-label
        data-cy="list-management-selected-products-text"
        class="list-select-all"
        (click)="selectAllProducts()"
      >
        {{ 'i18n.lists.selectAll' | translate }}
      </ion-label>
      <span data-cy="list-management-separator-text">|</span>
      <ion-label
        data-cy="list-management-selected-products-text"
        class="list-deselect-all"
        (click)="deselectAllProducts()"
      >
        {{ 'i18n.lists.deselectAll' | translate }}
      </ion-label>
    </div>
    <div class="selection-options">
      <ion-label
        data-cy="list-management-move-products-button"
        class="list-item-option"
        (click)="openSelectedProductsModal(ListActions.move)"
      >
        {{ 'i18n.lists.move' | translate }}
      </ion-label>
      <span data-cy="list-management-separator-text">|</span>
      <ion-label
        *ngIf="vm?.numProductsSelected > 0"
        data-cy="list-management-copy-products-button"
        class="list-item-option"
        (click)="openSelectedProductsModal(ListActions.copy)"
      >
        {{ 'i18n.lists.copy' | translate }}
      </ion-label>
      <span
        *ngIf="vm?.numProductsSelected > 0"
        data-cy="list-management-separator-text"
      >
        |
      </span>
      <ion-label
        data-cy="list-management-delete-products-button"
        class="list-item-option"
        (click)="openSelectedProductsModal(ListActions.delete)"
      >
        {{ 'i18n.common.delete' | translate }}
      </ion-label>
    </div>
  </ion-card>
</ng-template>

<!-- SEARCH, SORT & FILTER TEMPLATE -->
<ng-template #searchSortFilter>
  <div
    data-cy="list-detail-search-sort-filter-section"
    class="search-sort-filter-section"
  >
    <div class="search-container">
      <ion-searchbar
        id="list-search-bar-{{vm?.list?.listKey?.listId}}-0"
        data-cy="list-detail-searchbar"
        class="search"
        globalkeyhandler="filterBar"
        mode="md"
        placeholder="{{ 'i18n.lists.searchWithinYourList' | translate }}"
        [(ngModel)]="searchKey"
        (ionInput)="search()"
        (ionClear)="resetSearch()"
        (search)="search()"
      >
      </ion-searchbar>
    </div>
    <!-- <app-sort-and-filter-button
      [sortAndFilterCount]="vm?.sortAndFilterCount"
      (openSortAndFilterListModalEmitter)="handleOpenSortAndFilterListModal($event)"
      (clearSortAndFilterListModalEmitter)="handleClearSortAndFilterListModalEmitter($event)"
    ></app-sort-and-filter-button> -->
  </div>
</ng-template>

<!-- Download list modal-->
<ion-modal
  [isOpen]="listsOverlayService?.listDownloadModalOptions$?.value?.isOpen"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  (ionModalDidDismiss)="closeDownloadListModal()"
  [ngClass]="platformService.platformType !== platformService.platformEnum.desktop ? 'ion-modal-touch' : (listsOverlayService?.listDownloadModalOptions$?.value?.isDownload ? 'modal-desktop-size-lg' : 'download-print-desktop')"
>
  <ng-template>
    <app-download-list-v2
      class="ion-page"
      [platformType]="platformService?.platformType"
      [listName]="listsOverlayService?.listDownloadModalOptions$?.value?.listName"
      [listId]="listsOverlayService?.listDownloadModalOptions$?.value?.listId"
      [listTypeId]="listsOverlayService?.listDownloadModalOptions$?.value?.listTypeId"
      [isDownload]="listsOverlayService?.listDownloadModalOptions$?.value?.isDownload"
      [hidePricingOption]="vm?.selectedCustomer?.ogPrintPriceInd === 'N'"
      (dismissEvent)="closeDownloadListModal()"
      (downloadEmitter)="downloadList($event)"
    >
    </app-download-list-v2>
  </ng-template>
</ion-modal>

<!-- Download List Modal -->
<app-list-download-container
  [translateService]="translateService"
  (submitEvent)="downloadList($event)"
></app-list-download-container>

<!-- Print List Modal -->
<app-list-print-container
  [translateService]="translateService"
  (submitEvent)="downloadList($event)"
></app-list-print-container>

<!-- MAKE CHANGES HERE AS NEEDED AND DELETE COMMENT -->
<app-copy-products-modal-container
  [getListsLoaded]="getAccessibleListLoaded$"
  [getListsforUser]="getAccessibleListDataForUser$"
  [finalSubmission]="finalSubmissionForCopyProductsToList"
  [enableCopyToListFuc]="enableCopyToList"
  [hideCopyToListOptionFunc]="hideCopyToListOption"
>
</app-copy-products-modal-container>

<!-- Mass Delete Modal -->
<app-mass-delete-dual-pane-container></app-mass-delete-dual-pane-container>

<!-- New Search list modal -->
<app-new-search-simple-modal
  [isOpen]="isSearchModalOpen"
  (executeSearchEmitter)="handleSimpleSearchModalEvent($event)"
>
</app-new-search-simple-modal>

<!-- Add Products Action sheet-->
<ion-action-sheet
  class="action-sheet-touch"
  mode="ios"
  data-cy="add-products-action-sheet"
  [isOpen]="addProductsActionSheetIsOpen"
  [buttons]="addProductsButtons$ | async"
  (didDismiss)="addProductsActionSheetIsOpen = false"
></ion-action-sheet>

<!-- Add to list modal-->
<ion-modal
  [isOpen]="this.addToListModalService.isModalOpen$ | async"
  (ionModalDidDismiss)="this.addToListModalService.closeModal()"
  [class]="
  (platformService?.isTouchExperience$ | async)
    ? 'ion-modal-touch'
    : 'modal-desktop-size-xl'
"
  [initialBreakpoint]="
  platformService?.platformType !== platformService?.platformEnum.desktop
    ? 1
    : undefined
"
  [breakpoints]="
  platformService?.platformType !== platformService?.platformEnum.desktop
    ? [0, 1]
    : undefined
"
  id="addToListModal"
>
  <ng-template>
    <app-modal-with-nav-inline
      [rootPage]="this.addToListModalService.dualPaneRef"
      [rootPageParams]="this.addToListModalService.dualPaneModalData"
    >
    </app-modal-with-nav-inline>
  </ng-template>
</ion-modal>
